export const PATHS = {
    HOME: "/home",
    ABOUT: "/about",
    PORTFOLIO: "/portfolio",
    ENVIRONMENT: "/environment",
    RECRUITMENT: "/recruitment",
    CONTACT: "/contact",
    API_CONTACT:"https://api-wimobi.000webhostapp.com/contact"
}
